export enum MileageDownloadAllCSVRequestOrder {
  DATE_ASC = "DATE_ASC",
  DATE_DESC = "DATE_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  WORKER_NAME_ASC = "WORKER_NAME_ASC",
  WORKER_NAME_DESC = "WORKER_NAME_DESC",
  WORKER_LAST_NAME_ASC = "WORKER_LAST_NAME_ASC",
  WORKER_LAST_NAME_DESC = "WORKER_LAST_NAME_DESC",
  CARD_NO_ASC = "CARD_NO_ASC",
  CARD_NO_DESC = "CARD_NO_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  CARGO_COMPANY_NAME_ASC = "CARGO_COMPANY_NAME_ASC",
  CARGO_COMPANY_NAME_DESC = "CARGO_COMPANY_NAME_DESC",
}

export enum MileageDownloadAllCSVRequestVehicleType {
  COMPANY_OWNED = "COMPANY_OWNED",
  CAR_GT_900CM3 = "CAR_GT_900CM3",
  CAR_LE_900CM3 = "CAR_LE_900CM3",
  MOTORCYCLE = "MOTORCYCLE",
  MOPED = "MOPED",
}

export enum MileageDownloadAllCSVRequestState {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  DELEGATION_CREATED = "DELEGATION_CREATED",
}

export type MileageDownloadAllCSVRequestQueryParams = {
  order?: MileageDownloadAllCSVRequestOrder;
  cargo_company_name?: string;
  company_id?: string;
  date_since?: string;
  date_to?: string;
  human_id?: number;
  mileage_number?: string;
  worker_name?: string;
  card_number?: string;
  address?: string[];
  start_address?: string[];
  mid_address?: string[];
  end_address?: string[];
  distance_max?: number;
  distance_min?: number;
  vehicle_type?: MileageDownloadAllCSVRequestVehicleType;
  state?: MileageDownloadAllCSVRequestState;
};

type MileageDownloadAllCSVRequest = {
  order?: MileageDownloadAllCSVRequestOrder;
  company_id?: string;
  date_since?: string;
  date_to?: string;
  cargo_company_name?: string;
  human_id?: number;
  mileage_number?: string;
  worker_name?: string;
  card_number?: string;
  address?: string[];
  start_address?: string[];
  mid_address?: string[];
  end_address?: string[];
  distance_max?: number;
  distance_min?: number;
  vehicle_type?: MileageDownloadAllCSVRequestVehicleType;
  state?: MileageDownloadAllCSVRequestState;
};

export default MileageDownloadAllCSVRequest;
